import React from "react";
import { Link } from "react-router-dom"; // Import Link
import about from "../../assets/images/aboutUspage/side_about_us_excellence.svg";
// import banner from "../../assets/images/aboutUspage/about-us-bg.svg";
import arrow from "../../assets/images/Arrow 1.png";


function AboutusContent() {
  return (
    <section>
      <div className="about_area py-5 mt-header about-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <div className="about-image-wrapper">
                <img
                  src={about}
                  alt="About Us"
                  className="img-fluid w-100"
                  style={{ objectFit: 'cover', borderRadius: '30px' }}
                />
              </div>
            </div>
            <div className="col-lg-6 ps-lg-5">
              <div className="about-content">
                <div className="about-badge mb-3">Who We Are</div>
                <h1 className="about-title mb-4">
                  We Deliver <span className="gradient-text">Excellence</span> <br />
                  In Every Line of Code
                </h1>
                
                <div className="about-description">
                  <p className="mb-4">
                    Welcome to Centillion, a trusted software development partner with a global footprint. 
                    For over 4 years, we've been helping enterprises transform their digital presence 
                    through innovative solutions and strategic consulting.
                  </p>
                  
                  <ul className="feature-list mb-5">
                    <li className="feature-item">
                      <div className="feature-icon-wrapper">
                        <i className="fa-regular fa-check"></i>
                      </div>
                      <div>Enterprise-Grade Solutions</div>
                    </li>
                    <li className="feature-item">
                      <div className="feature-icon-wrapper">
                        <i className="fa-regular fa-check"></i>
                      </div>
                      <div>Innovative Information Integration</div>
                    </li>
                    <li className="feature-item">
                      <div className="feature-icon-wrapper">
                        <i className="fa-regular fa-check"></i>
                      </div>
                      <div>Collaborative Governance Tools</div>
                    </li>
                  </ul>

                  <Link className="modern-btn primary" to="/service">
                    Discover More
                    <i className="fa-regular fa-arrow-right ms-2"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}


export default AboutusContent;
